"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSegment = void 0;
/** Marketing segments (TZ §32). Evaluated server-side against live data. */
exports.CustomerSegment = {
    NEW: 'NEW',
    VIP: 'VIP',
    INACTIVE_30D: 'INACTIVE_30D',
    TOP_SPENDER: 'TOP_SPENDER',
    FREQUENT: 'FREQUENT',
};
//# sourceMappingURL=crm.js.map